var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var convertToOrderedOption = function (dto) { return ({
    element: {
        id: dto.id,
        name: dto.name,
        description: dto.description,
    },
    order: dto.order,
}); };
export var convertMasterData = function (masterDataDto) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37, _38, _39, _40, _41;
    return {
        accessLevel: masterDataDto.access_level,
        businessAreas: masterDataDto.business_areas,
        paymentTypes: masterDataDto.payment_types,
        petTypes: masterDataDto.pet_types,
        petAges: masterDataDto.pet_ages,
        ageOptions: masterDataDto.pet_age,
        petSizes: ((_a = masterDataDto.pet_sizes) === null || _a === void 0 ? void 0 : _a.map(function (size) { return ({
            element: {
                id: size.id,
                name: size.name,
                description: size.description,
                minWeight: size.min_weight,
                maxWeight: size.max_weight,
            },
            order: size.order,
        }); })) || [],
        dogHairTypes: ((_b = masterDataDto.pet_hair_types) === null || _b === void 0 ? void 0 : _b.dog.map(function (type) {
            return convertToOrderedOption(type);
        })) || [],
        dogHairLengths: ((_c = masterDataDto.pet_hair_lengths) === null || _c === void 0 ? void 0 : _c.dog.map(function (length) {
            return convertToOrderedOption(length);
        })) || [],
        catHairTypes: ((_d = masterDataDto.pet_hair_types) === null || _d === void 0 ? void 0 : _d.cat.map(function (type) {
            return convertToOrderedOption(type);
        })) || [],
        catHairLengths: ((_e = masterDataDto.pet_hair_lengths) === null || _e === void 0 ? void 0 : _e.cat.map(function (length) {
            return convertToOrderedOption(length);
        })) || [],
        catColors: masterDataDto.cat_hair_colors,
        dogColors: masterDataDto.dog_hair_colors,
        exoticColors: masterDataDto.exotic_hair_colors,
        petExoticTypes: masterDataDto.pet_exotic_types,
        petGenders: masterDataDto.pet_gender,
        grooming: {
            visibility: (_f = masterDataDto.grooming) === null || _f === void 0 ? void 0 : _f.visibility,
            holdingAreas: (_g = masterDataDto.grooming) === null || _g === void 0 ? void 0 : _g.holding_areas,
            sizeSeparation: (_h = masterDataDto.grooming) === null || _h === void 0 ? void 0 : _h.size_separation,
            security: (_j = masterDataDto.grooming) === null || _j === void 0 ? void 0 : _j.security,
            locationTypes: (_k = masterDataDto.grooming) === null || _k === void 0 ? void 0 : _k.location_types,
        },
        daycare: {
            visibility: (_l = masterDataDto.daycare) === null || _l === void 0 ? void 0 : _l.visibility,
            sizeSeparation: (_m = masterDataDto.daycare) === null || _m === void 0 ? void 0 : _m.size_separation,
            recreationalPerks: (_o = masterDataDto.daycare) === null || _o === void 0 ? void 0 : _o.recreational_perks,
            security: (_p = masterDataDto.daycare) === null || _p === void 0 ? void 0 : _p.security,
            extras: (_q = masterDataDto.daycare) === null || _q === void 0 ? void 0 : _q.extras,
        },
        boarding: {
            visibility: (_r = masterDataDto.boarding) === null || _r === void 0 ? void 0 : _r.visibility,
            sizeSeparation: (_s = masterDataDto.boarding) === null || _s === void 0 ? void 0 : _s.size_separation,
            facilityTours: (_t = masterDataDto.boarding) === null || _t === void 0 ? void 0 : _t.facility_tours,
            overnightCare: (_u = masterDataDto.boarding) === null || _u === void 0 ? void 0 : _u.overnight_care,
            recreationalPerks: (_v = masterDataDto.boarding) === null || _v === void 0 ? void 0 : _v.recreational_perks,
            security: (_w = masterDataDto.boarding) === null || _w === void 0 ? void 0 : _w.security,
            extras: (_x = masterDataDto.boarding) === null || _x === void 0 ? void 0 : _x.extras,
        },
        staff: {
            training: (_y = masterDataDto.staff) === null || _y === void 0 ? void 0 : _y.training,
        },
        status: masterDataDto.status,
        serviceTags: masterDataDto.service_tags,
        roles: masterDataDto.roles,
        relationships: masterDataDto.relationships,
        smsCampaignsStatus: masterDataDto.sms_campaign_statuses || [],
        dentalReportOptions: {
            dentalProcedures: ((_z = masterDataDto.dental_report_options) === null || _z === void 0 ? void 0 : _z.dental_procedures.map(function (option) { return ({
                id: option.id,
                name: option.name,
            }); })) || [],
            homecare: ((_0 = masterDataDto.dental_report_options) === null || _0 === void 0 ? void 0 : _0.homecare_options.map(function (option) { return ({
                id: option.id,
                name: option.name,
            }); })) || [],
            periodontalFindings: ((_1 = masterDataDto.dental_report_options) === null || _1 === void 0 ? void 0 : _1.periodontal_findings.map(function (option) { return ({
                id: option.id,
                name: option.name,
            }); })) || [],
            recommendations: ((_2 = masterDataDto.dental_report_options) === null || _2 === void 0 ? void 0 : _2.recommendations.map(function (option) { return ({
                id: option.id,
                name: option.name,
            }); })) || [],
            toothAbnormalities: ((_3 = masterDataDto.dental_report_options) === null || _3 === void 0 ? void 0 : _3.tooth_abnormalities.map(function (option) { return ({
                id: option.id,
                name: option.name,
            }); })) || [],
        },
        breeds: {
            dogs: masterDataDto.pet_breeds ? masterDataDto.pet_breeds[0].dogs : [],
            cats: masterDataDto.pet_breeds ? masterDataDto.pet_breeds[0].cats : [],
            exotics: masterDataDto.pet_breeds
                ? masterDataDto.pet_breeds[0].exotics
                : [],
        },
        groomingReportOptions: {
            skin: ((_4 = masterDataDto.grooming_report_options) === null || _4 === void 0 ? void 0 : _4.skin) || [],
            teeth: ((_5 = masterDataDto.grooming_report_options) === null || _5 === void 0 ? void 0 : _5.teeth) || [],
            nails: ((_6 = masterDataDto.grooming_report_options) === null || _6 === void 0 ? void 0 : _6.nails) || [],
            coat: ((_7 = masterDataDto.grooming_report_options) === null || _7 === void 0 ? void 0 : _7.coat) || [],
            ears: ((_8 = masterDataDto.grooming_report_options) === null || _8 === void 0 ? void 0 : _8.ears) || [],
            eyes: ((_9 = masterDataDto.grooming_report_options) === null || _9 === void 0 ? void 0 : _9.eyes) || [],
            behavior: ((_10 = masterDataDto.grooming_report_options) === null || _10 === void 0 ? void 0 : _10.behavior) || [],
            findings: ((_11 = masterDataDto.grooming_report_options) === null || _11 === void 0 ? void 0 : _11.findings) || [],
            recommendations: ((_12 = masterDataDto.grooming_report_options) === null || _12 === void 0 ? void 0 : _12.recommendations) || [],
            findingPlaces: ((_13 = masterDataDto.grooming_report_options) === null || _13 === void 0 ? void 0 : _13.finding_places) || [],
        },
        medicalHistory: {
            dentals: (_14 = masterDataDto.dental_history_types) === null || _14 === void 0 ? void 0 : _14.map(function (dto) { return ({
                id: dto.id,
                name: dto.name,
            }); }),
            medicalConditionCategories: ((_15 = masterDataDto.medical_condition_categories) === null || _15 === void 0 ? void 0 : _15.map(function (cat) {
                var _a;
                return ({
                    id: cat.id,
                    uuid: cat.uuid,
                    name: cat.name,
                    description: cat.description,
                    icon: cat.font_awesome_icon,
                    options: ((_a = cat.medical_conditions) === null || _a === void 0 ? void 0 : _a.map(function (mc) { return ({
                        id: mc.id,
                        uuid: mc.uuid,
                        name: mc.name,
                        description: mc.description,
                        active: mc.active,
                    }); })) || [],
                    active: cat.active,
                });
            })) || [],
            behaviorConditionCategories: ((_16 = masterDataDto.behavior_conditions_categories) === null || _16 === void 0 ? void 0 : _16.map(function (cat) {
                var _a;
                return ({
                    id: cat.id,
                    uuid: cat.uuid,
                    name: cat.name,
                    description: cat.description,
                    icon: cat.font_awesome_icon,
                    options: ((_a = cat.behavior_conditions) === null || _a === void 0 ? void 0 : _a.map(function (bc) { return ({
                        id: bc.id,
                        uuid: bc.uuid,
                        name: bc.name,
                        description: bc.description,
                        active: bc.active,
                    }); })) || [],
                    active: cat.active,
                });
            })) || [],
        },
        petRequirements: masterDataDto.pet_requirements,
        imagesMaxSizes: {
            groomingReportMaxKb: ((_17 = masterDataDto.images_max_sizes) === null || _17 === void 0 ? void 0 : _17.grooming_report_kb) || 2048,
            dentalReportKb: ((_18 = masterDataDto.images_max_sizes) === null || _18 === void 0 ? void 0 : _18.dental_report_kb) || 2048,
            squareLogoKb: ((_19 = masterDataDto.images_max_sizes) === null || _19 === void 0 ? void 0 : _19.vertical_logo_kb) || 2048,
            squareLogo: {
                maxSizeKb: ((_20 = masterDataDto.images_max_sizes) === null || _20 === void 0 ? void 0 : _20.vertical_logo_kb) || 2048,
                maxWidthPx: ((_21 = masterDataDto.images_max_sizes) === null || _21 === void 0 ? void 0 : _21.vertical_logo_width) || 600,
                maxHeightPx: ((_22 = masterDataDto.images_max_sizes) === null || _22 === void 0 ? void 0 : _22.vertical_logo_height) || 600,
                imageTypes: ((_23 = masterDataDto.images_max_sizes) === null || _23 === void 0 ? void 0 : _23.vertical_logo_img_types) || [
                    "png",
                    "jpg",
                ],
            },
            horizontalLogoKb: ((_24 = masterDataDto.images_max_sizes) === null || _24 === void 0 ? void 0 : _24.horizontal_logo_kb) || 2048,
            horizontalLogo: {
                maxSizeKb: ((_25 = masterDataDto.images_max_sizes) === null || _25 === void 0 ? void 0 : _25.horizontal_logo_kb) || 2048,
                maxWidthPx: ((_26 = masterDataDto.images_max_sizes) === null || _26 === void 0 ? void 0 : _26.horizontal_logo_width) || 500,
                maxHeightPx: ((_27 = masterDataDto.images_max_sizes) === null || _27 === void 0 ? void 0 : _27.horizontal_logo_height) || 200,
                imageTypes: ((_28 = masterDataDto.images_max_sizes) === null || _28 === void 0 ? void 0 : _28.horizontal_logo_img_types) || ["png", "jpg"],
            },
            avatarKb: ((_29 = masterDataDto.images_max_sizes) === null || _29 === void 0 ? void 0 : _29.avatar_kb) || 2048,
            onlineBookingImage: {
                maxSizeKb: ((_30 = masterDataDto.images_max_sizes) === null || _30 === void 0 ? void 0 : _30.online_booking_image_kb) || 2048,
                maxWidthPx: ((_31 = masterDataDto.images_max_sizes) === null || _31 === void 0 ? void 0 : _31.online_booking_image_width) || 980,
                maxHeightPx: ((_32 = masterDataDto.images_max_sizes) === null || _32 === void 0 ? void 0 : _32.online_booking_image_height) || 1200,
                imageTypes: ((_33 = masterDataDto.images_max_sizes) === null || _33 === void 0 ? void 0 : _33.online_booking_image_img_types) || ['png', 'jpg'],
            }
        },
        vaccines: masterDataDto.vaccines,
        emailContent: masterDataDto.email_default_recommendations
            ? __spreadArray([], masterDataDto.email_default_recommendations, true) : [],
        payments: {
            phoneTypes: __spreadArray([], (masterDataDto.phone_types || []), true),
            documentTypes: {
                businessProfile: __spreadArray([], (masterDataDto.business_profile_document_types || []), true),
                shareholder: __spreadArray([], (masterDataDto.shareholder_document_types || []), true),
                bankAccount: __spreadArray([], (masterDataDto.bank_account_document_types || []), true),
            },
            genders: __spreadArray([], (masterDataDto.genders || []), true),
            verificationStatuses: __spreadArray([], (masterDataDto.verification_statuses || []), true),
            refundStatuses: __spreadArray([], (masterDataDto.refund_statuses || []), true),
            shareholderTypes: __spreadArray([], (masterDataDto.shareholder_types || []), true),
            bankAccountTypes: __spreadArray([], (masterDataDto.bank_account_types || []), true),
            bankAccountCountries: __spreadArray([], (masterDataDto.bank_account_country_codes || []), true),
            currencies: __spreadArray([], (masterDataDto.currencies || []), true),
            files: {
                pdf: {
                    maxSizeBytes: ((_35 = (_34 = masterDataDto.upload_file_size) === null || _34 === void 0 ? void 0 : _34.find(function (size) { return size.id.toLowerCase() === "pdf"; })) === null || _35 === void 0 ? void 0 : _35.max) || 4 * 1024 * 1024,
                    minSizeBytes: ((_37 = (_36 = masterDataDto.upload_file_size) === null || _36 === void 0 ? void 0 : _36.find(function (size) { return size.id.toLowerCase() === "pdf"; })) === null || _37 === void 0 ? void 0 : _37.min) || 10 * 1024,
                },
                image: {
                    maxSizeBytes: ((_39 = (_38 = masterDataDto.upload_file_size) === null || _38 === void 0 ? void 0 : _38.find(function (size) { return size.id.toLowerCase() === "image"; })) === null || _39 === void 0 ? void 0 : _39.max) || 4 * 1024 * 1024,
                    minSizeBytes: ((_41 = (_40 = masterDataDto.upload_file_size) === null || _40 === void 0 ? void 0 : _40.find(function (size) { return size.id.toLowerCase() === "image"; })) === null || _41 === void 0 ? void 0 : _41.min) || 100 * 1024,
                },
            },
            paymentMethods: __spreadArray([], (masterDataDto.payment_methods || []), true),
            statuses: __spreadArray([], (masterDataDto.payment_statuses || []), true),
        },
        usStates: __spreadArray([], (masterDataDto.us_states || []), true),
        caStates: __spreadArray([], (masterDataDto.ca_states || []), true),
        countryCodes: __spreadArray([], (masterDataDto.country_codes || []), true),
        countries: __spreadArray([], (masterDataDto.countries || []), true).map(function (dto) {
            return convertCountry(dto);
        }),
        productUnits: __spreadArray([], (masterDataDto.units_of_measure || []), true),
        scheduleFrecuency: __spreadArray([], (masterDataDto.schedule_frecuency || []), true),
        scheduleDuration: __spreadArray([], (masterDataDto.schedule_duration || []), true),
        taxOptions: __spreadArray([], (masterDataDto.tax_options || []), true),
        orderStatuses: (masterDataDto.order_statuses || []).map(function (order) { return ({
            id: order.id,
            name: order.name,
            backgroundColor: order.background_color,
            fontColor: order.font_color,
        }); }),
        terminalsModels: (masterDataDto.terminal_models || []).map(function (order) { return ({
            id: order.id,
            name: order.name,
            description: order.description,
            price: order.price,
            type: order.type,
        }); }),
        clientTags: {
            positive: __spreadArray([], (masterDataDto.marketing_positive || []), true),
            negative: __spreadArray([], (masterDataDto.marketing_negative || []), true),
        },
        hearAboutUsOptions: __spreadArray([], (masterDataDto.hear_about_us || []), true),
        agreementsSendTo: __spreadArray([], (masterDataDto.agreements_send_to || []), true),
        timeZones: __spreadArray([], (masterDataDto.time_zones || []), true),
        resourceAccessPlans: (masterDataDto.access_permissions || []).map(function (access) { return ({
            planId: access.id,
            allowedResources: (access.resources || []).map(function (resource) { return ({
                resourceId: resource.id,
            }); }),
        }); }),
        resourceAccessLevels: (masterDataDto.access_level_permissions || []).map(function (access) { return ({
            accessLevelId: access.id,
            allowedResources: (access.resources || []).map(function (resource) { return ({
                resourceId: resource.id,
            }); }),
        }); }),
        subscriptionPlans: __spreadArray([], (masterDataDto.subscription_categories || []), true).map(function (planDto) { return ({
            id: planDto.id,
            name: planDto.name,
            value: planDto.value,
        }); }),
        olbFromLimits: __spreadArray([], (masterDataDto.olb_minimum_lead_times || []), true).map(function (limit) { return convertToLimit(limit); }),
        olbToLimits: __spreadArray([], (masterDataDto.olb_maximum_lead_times || []), true).map(function (limit) { return convertToLimit(limit); }),
        commissions: convertToCommissions(masterDataDto),
        locations: __spreadArray([], (masterDataDto.locations || []), true),
        groomers: __spreadArray([], (masterDataDto.groomers || []), true),
        softwares: __spreadArray([], (masterDataDto.software || []), true),
        services: __spreadArray([], (masterDataDto.services || []), true),
        workflow: convertToWorkflow(masterDataDto),
        blockFrequencies: __spreadArray([], (masterDataDto.block_calendar_frequencies || []), true),
        cancelationReasons: __spreadArray([], (masterDataDto.cancelation_reasons || []), true),
        serviceColors: __spreadArray([], (masterDataDto.service_colors || []), true).map(function (serviceColor) {
            return convertToServiceColors(serviceColor);
        }),
        petNegativePersonality: __spreadArray([], (masterDataDto.pet_negative_personalities || []), true).map(function (negativeDto) { return ({
            id: negativeDto.id,
            name: negativeDto.name
        }); }),
        petPositivePersonality: __spreadArray([], (masterDataDto.pet_positive_personalities || []), true).map(function (positiveDto) { return ({
            id: positiveDto.id,
            name: positiveDto.name
        }); }),
        defaultContentNotifications: __spreadArray([], (masterDataDto.default_content_notifications || []), true).map(function (defaultContent) { return convertDefaultContentNotification(defaultContent); }),
        notificationPlaceholders: __spreadArray([], (masterDataDto.notification_placeholders || []), true).map(function (placeholder) { return convertNotificationPlaceholder(placeholder); }),
        enrollmentTypes: __spreadArray([], (masterDataDto.enrollment_types || []), true),
        rolloverUsages: __spreadArray([], (masterDataDto.rollover_usages || []), true),
        enrollmentBillingFrequencies: __spreadArray([], (masterDataDto.enrollment_billing_frequency || []), true),
    };
};
var convertCountry = function (dto) { return ({
    code: dto.code,
    currency: dto.currency,
    flag: dto.flag,
    id: dto.id,
    name: dto.name,
    phoneCode: dto.phone_code,
}); };
var convertToLimit = function (dto) { return ({
    id: dto.id,
    name: dto.name,
    offsetSeconds: dto.time,
}); };
var convertToCommissions = function (dto) {
    var _a, _b;
    return ({
        categories: (_a = dto.commission_categories) !== null && _a !== void 0 ? _a : [],
        cadences: (_b = dto.commission_cadences) !== null && _b !== void 0 ? _b : [],
    });
};
var convertToWorkflow = function (dto) {
    return (dto.booking_statuses || []).map(function (statusDto) { return ({
        status: {
            id: statusDto.id,
            name: statusDto.name,
        },
        isReschedulable: statusDto.rechedule,
        actions: statusDto.actions.map(function (actionDto) { return ({
            action: actionDto.action,
            nextStatus: {
                id: actionDto.id,
                name: actionDto.name,
            },
            show: actionDto.show
        }); }),
    }); });
};
var convertDefaultContentNotification = function (dto) { return ({
    id: dto.key,
    name: dto.name,
    description: dto.content
}); };
var convertNotificationPlaceholder = function (dto) { return ({
    id: dto.id,
    name: dto.name,
    description: dto.value,
}); };
var convertToServiceColors = function (dto) { return ({
    id: dto.id,
    name: dto.value,
}); };
